import {FC, useCallback} from "react";
import Button, {ButtonProps} from "@memaro/components/Button.tsx";
import Delete from "@mui/icons-material/Delete";
import {useFeedback} from "@memaro/feedback";

type DeleteButtonProps = ButtonProps & {
    index: number,
    onClick: (index: number) => void
}

const DeleteButton: FC<DeleteButtonProps> = ({index, onClick, ...rest}) => {
    const {confirm} = useFeedback()

    const handleClick = useCallback(async () => {
        if (await confirm?.("Weet u zeker dat u deze foto wil verwijderen?")) {
            onClick(index)
        }
    }, [confirm, index, onClick])

    return (
        <Button color="error" onClick={handleClick} {...rest}>
            <Delete />
            <span>Foto verwijderen</span>
        </Button>
    )
}


export default DeleteButton
